import React, { useEffect, useState } from "react";
import Breadcrumbs from "components/Common/Breadcrumb";
import { MetaTags } from "react-meta-tags";
import { Col, Container, Row } from "reactstrap";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import ErrorAlert from "components/Alerts/error";
import UserReferralList from "./UserReferralList";

export const UserReferralMainPage = () => {

  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title></title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="User Referrals"
            breadcrumbItem="User Referal Page"
          />
          <BreadcrumbSub
            subtile="Users Referrels List"
            SubBreadcrumbItem="Referrels"
          />

          <Row className=" mt-3">
            <Col>
              <UserReferralList />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default UserReferralMainPage;
